// extracted by mini-css-extract-plugin
export default {"modalWrapper":"EditTeacherModal_modalWrapper__FnDY+"};